type ObjectWithSortNumber = {
  sortOrder: string
}

export const sortAscByOrder = (a: ObjectWithSortNumber, b: ObjectWithSortNumber) => Number.parseInt(a.sortOrder) - Number.parseInt(b.sortOrder)

// const sortDescByOrder = (a: ObjectWithSortNumber, b: ObjectWithSortNumber) => Number.parseInt(b.sortOrder) - Number.parseInt(a.sortOrder)
